const cleanEmptyProps = function cleanEmptyProps(obj) {
	Object.keys(obj).filter((k) => obj[k] === null).forEach((k) => {
		// eslint-disable-next-line no-param-reassign
		delete obj[k];
	});
	return obj;
};

export default cleanEmptyProps;
